import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { AuthResponse, AuthService } from '../auth.service';

@Component({
  selector: 'token-verification',
  standalone: true,
  imports:[RouterLink],
  templateUrl: './token-verification.component.html',
  styleUrls: ['./token-verification.component.css']
})
export class TokenVerificationComponent implements OnInit{

  isLoading: boolean = true;
  isTokenValid: boolean = false;
  tokenResponse: AuthResponse;

  constructor(private route: ActivatedRoute, private authService: AuthService, private router: Router){}

  async handleRouting(tokenType: string){
    switch(tokenType){

      case 'email-verify':

        this.tokenResponse = await this.authService.verifyEmail(this.tokenResponse.token);
        this.tokenResponse.type = 'Email verified';
        if(this.tokenResponse){
          this.isTokenValid = true;
        }

      break;

      case 'email-update':
      
        this.isTokenValid = await this.authService.emailUpdate(this.tokenResponse.token);
        this.isTokenValid = true;
        this.tokenResponse.type = 'Email update';

      break;

      case 'email-revert':
      
        this.isTokenValid = await this.authService.revertEmail(this.tokenResponse.token);
        this.isTokenValid = true;
        this.tokenResponse.type = 'Email revert';

      break;

      case 'password-reset':
        
        this.tokenResponse.type = 'Password reset';
        this.isTokenValid = true;
        this.router.navigate(['/reset-password']);

      break;

      case 'account-deletion':

        this.tokenResponse.type = 'Account deletion';
        this.authService.confirmAccountDeletion(this.tokenResponse.token);
        this.isTokenValid = true;

      break;


      default:

        this.tokenResponse.type = 'Verified';
        this.isTokenValid = true;

      break;


    }
  }


  ngOnInit(): void {
    this.isLoading = true;
    this.isTokenValid = false;
    this.tokenResponse = new AuthResponse();
    this.route.queryParams.subscribe(async (params) =>{
      this.isLoading = true;
      this.isTokenValid = false;

      let token: string = params['token'];
      if(token !== undefined){
      
          this.tokenResponse = await this.authService.validateToken(token).catch(() => new AuthResponse());

          if(this.tokenResponse){
            const expTime: Date = new Date(this.tokenResponse.expires as any);
            const now = new Date();
          
          
            if(expTime.getTime() > now.getTime()){
              this.isTokenValid = true;
              await this.handleRouting(this.tokenResponse.type);
              // token has not expired
              await this.authService.storeVerificationToken(this.tokenResponse);
            
            }
          }
      }
      this.isLoading = false;
      
    });
  }

}
